import React from 'react';
import PropTypes from 'prop-types';

export default class ClassDetail extends React.Component {
	static propTypes = {
		classList: PropTypes.object,
		data: PropTypes.object,
		onChange: PropTypes.func,
		onNextPage: PropTypes.func,
	};

	constructor( props ) { 
		super( props );

		this.state = { 
			tested: {},
		};

		if( ! this.props.data['classnum'] ) { 
			this.props.onNextPage( 2 );
		}

		this.item = null;
		for( let i = 0; i < this.props.classList.length; i ++ ) { 
			if( parseInt( this.props.classList[i].classnum ) === parseInt( this.props.data['classnum'] ) ) { 
				this.item = this.props.classList[ i ];
				break;
			}
		}

		if( ! this.item ) { 
			this.props.onNextPage( 2 );
		}
	}

	remoteTestItem( id, val, callback ) {
		var tested = this.state.tested;
		tested[ id ] = { status: false, running: true, err: '', extra: { curval: '' } };
		this.setState( { tested } ); 

		jQuery.ajax( {
			method: "POST",
			url: window.dt_js_details.ajax_url,
			data: { action: 'dt_signup_test_item', id: id, value: val, classnum: this.props.data['classnum'] }
		} )
			.done( msg => {
				var tested = this.state.tested;
				tested[ id ] = { status: msg.status, err: msg.err, extra: { curval: val }, running: false };
				this.setState( { tested } );

				if( callback ) { callback( msg ); }
			} )
			.fail( () => {
				window.alert( "Issue connecting to server to test item" );
			} );
	}

	onNextPage() { 
		this.remoteTestItem( 'classpass', this.props.data['classpass'], e => { 
			if( e.status === true ) { 
				this.props.onNextPage();
			}
		} );
	}

	render() {
		let ctr = 1;

		if( ! this.item ) { return []; }

		return ( <div className="classdetails_container">
			<h2>You are signing up for &quot;{ this.item.classname }&quot;</h2>
			<strong>The following items are needed to sign up for this class:</strong>

			{ this.item.require_password ? 
				<div>
					<strong> { ctr ++ }. A password is required for this class:</strong> 
					<input type="text" value={ this.props.data['classpass'] ? this.props.data['classpass'] : '' } onChange={ e => { this.props.onChange( 'classpass', e.target.value );}} />

					{ this.state.tested['classpass'] && ! this.state.tested['classpass'].status ? 
						<div className="error">{ this.state.tested['classpass'].err }</div> : '' }
					{ this.state.tested['classpass'] && this.state.tested['classpass'].running ? 
						<div className="error">Testing...</div> : '' }
				</div> : [] 
			}
			{ this.item.select_domain_dragonteach || this.item.select_domain_other  ? 
				<div>
					<strong> { ctr ++ }. You will be given the option to select a domain once you have verified your account</strong> 
				</div> : [] 
			}
			{ this.item.student_pay ? 
				<div>
					<strong> { ctr ++ }. You will be given the options to pay once you have verified your account</strong> 
				</div> : [] 
			}

			<div className="button_container">
				<input type="button" value="Finish Signup" onClick={ () => { this.onNextPage(); } } />
			</div>

		</div>
		);
	}
}